import { RouteObject } from 'react-router-dom';
import { CoreBox, CoreTextEllipsis, CoreTypography } from '@youscience/core';
import { QueryClient } from '@tanstack/react-query';
import { getGroupCrumb, getTenantCrumb } from '@stores/breadCrumbStore';
import BreadcrumbLink from '@components/layout/Breadcrumbs/BreadcrumbLink';
import { ORGANIZATION_ROUTES, TAGS_ROUTES } from '.';
import ErrorPage from '../error-page';
import { commonTenantBreadCrumbs } from './commonBreadcrumbs';

const queryClient = new QueryClient();

export const tagsRoutes: RouteObject[] = [
  {
    path: `${TAGS_ROUTES.ROOT_ROUTE}/${TAGS_ROUTES.TAGS_MANAGEMENT}`,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        async lazy() {
          const { TagsManagement } = await import('@features/tags/TagsManagement/TagsManagement');

          return { Component: TagsManagement };
        },
        errorElement: <ErrorPage />,
        async loader() {
          const { tagsLoader } = await import('@features/tags/loaders');

          return tagsLoader(queryClient);
        },
        handle: {
          crumb: () => {
            // FIXME: crumbTenant is null
            const crumbTenant = getTenantCrumb();
            const tenantId = crumbTenant?.tenantId ?? '';
            const tenantName = crumbTenant?.name ?? '';

            return [
              ...commonTenantBreadCrumbs(tenantId, tenantName),
              <CoreTypography color='text.secondary'>Tags management</CoreTypography>,
            ];
          },
        },
      },
      {
        path: `${TAGS_ROUTES.TAG_DETAILS}`,
        async lazy() {
          const { TagDetail } = await import('@features/tags/TagDetail/TagDetail');

          return { Component: TagDetail };
        },
        errorElement: <ErrorPage />,
        async loader() {
          const { tagDetailsLoader } = await import('@features/tags/loaders');

          return tagDetailsLoader(queryClient);
        },
        handle: {
          crumb: () => {
            // TODO: need to configure a store or use react-router context to pass the tenantName
            const crumbTenant = getTenantCrumb();
            const tagCrumb = getGroupCrumb();

            const tenantId = crumbTenant?.tenantId ?? '';
            const tenantName = crumbTenant?.name ?? '';
            const tagName = tagCrumb?.name ?? 'Tag Name';

            return [
              ...commonTenantBreadCrumbs(tenantId, tenantName),

              <BreadcrumbLink to={`/${ORGANIZATION_ROUTES.ORGANIZATIONS}/${tenantId}/${TAGS_ROUTES.TAGS_MANAGEMENT}`}>
                Tags management
              </BreadcrumbLink>,

              <CoreBox sx={{ width: '100%', maxWidth: 230 }}>
                <CoreTextEllipsis variant='body1' component='div' value={tagName} symbolLimit={30} />
              </CoreBox>,
            ];
          },
        },
      },
    ],
  },
  {
    path: `${TAGS_ROUTES.ROOT_ROUTE}/${TAGS_ROUTES.NEW_TAG}`,
    async lazy() {
      const { NewTag } = await import('@features/tags/NewTag/NewTag');

      return { Component: NewTag };
    },
    errorElement: <ErrorPage />,
  },
];
